import { removeTokens } from 'shared/tokens';

/** Clears all persistent state */
export const clearStorage = () => {
  sessionStorage.clear();
  removeTokens();
};
